export const getInitials = (fullName?: string): string => {
  const trimmedName = fullName?.trim() // Trim leading and trailing spaces
  const words = trimmedName?.split(' ')

  if (!words || words.length === 0) {
    return ''
  }

  const firstInitial = words[0][0]
  const lastInitial = words[words.length - 1][0]

  if (words.length === 1) {
    return firstInitial
  }

  return `${firstInitial}${lastInitial}`
}
